<template>
  <input-widget :rules="rules" type="select2" :attribute="attribute" :items="items" :search-handler="handler"
                display-field="Receipt: ${item.receipt_no}" :hint="hint" :model="model" :info-text="infoText"
                :label="label" @select2Select="onSelect" @select2Unselect="onUnselect" :disabled="disabled"
                :options="options" :multiple="multiple"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import ReceiptService from "../../modules/receipt/ReceiptService";
  import {uuid} from 'vue-uuid';

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ReceiptSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      expand: {
        type: String,
        default: ''
      },
      infoText: {
        type: String,
        default: null
      },
      withDummyReceipt: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      filterKey: {
        type: String,
        default: 'receipt_no',
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return {minimumInputLength: 1};
        }
      },
      customerUuid: {
        type: String,
        default: null
      },
      branchUuid: {
        type: String,
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },
      removeDuplicates: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      async handler(val) {
        let key = this.filterKey;
        let params = {
          [key]: val,
          ordering: 'receipt_no'
        }

        if (this.customerUuid) {
          params['customer_uuid'] = this.customerUuid;
        }

        if (this.branchUuid) {
          params['branch_uuid'] = this.branchUuid;
        }

        let response = await ReceiptService.getReceipts(params, this.expand);

        if (this.removeDuplicates && this.multiple && this.model[this.attribute] && this.model[this.attribute].length > 0) {
          const tmpStr = this.model[this.attribute].join('|')
          response.body.results = response.body.results.filter(r => !tmpStr.includes(r.uuid))
        }

        if (!response.success || !this.withDummyReceipt) {
          return response;
        }

        let responseBody = response.body;
        let dummyReceipt = {
          uuid: uuid.v4(),
          is_dummy: true,
          [key]: val
        };

        if (responseBody.results.length === 0) {
          responseBody.results = [dummyReceipt];
        } else {
          let hasExactReceipt = responseBody.results.find(r => r[key] === val);
          if (!hasExactReceipt) {
            responseBody.results.unshift(dummyReceipt)
          }
        }

        return {
          success: true,
          body: responseBody
        }
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid') {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - 5);
          if (this.model[toListenAttribute]) {
            this.items.push(this.model[toListenAttribute]);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute] && this.model[toListenAttribute].uuid === this.model[this.attribute]) {
              this.items.push(this.model[toListenAttribute]);
            }
          }, {deep: true});
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect(data) {
        this.$emit('unselect', data);
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
